import request from '@/utils/request'

const URL = '/webserver/waybill/vehicleMonitor/selected-vehicles'

function selectionRows(response) {
  if (!response || !Array.isArray(response.data) || response.data.some(row => !row || !row.vehicleNo || !['1', '2', '3'].includes(String(row.plateColor)))) {
    throw new Error('已选车辆响应格式不正确')
  }
  return response.data
}

export async function fetchVehicleQuerySelections() {
  return selectionRows(await request.get(URL))
}

export async function addVehicleQuerySelections(vehicles) {
  return selectionRows(await request.post(URL, { vehicles }))
}

export async function removeVehicleQuerySelections(vehicles) {
  return selectionRows(await request.delete(URL, { data: { vehicles } }))
}
